(function () {
  const STORAGE_KEY = "sparkmoto-settings-v2";

  const defaults = {
    textSize: "1",
    font: "plank"
  };

  const validSizes = ["0.5", "1", "1.5", "2", "3"];
  const validFonts = ["plank", "shopify"];

  function readSettings() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};

      return {
        textSize: validSizes.includes(saved.textSize)
          ? saved.textSize
          : defaults.textSize,
        font: validFonts.includes(saved.font)
          ? saved.font
          : defaults.font
      };
    } catch (error) {
      return { ...defaults };
    }
  }

  let settings = readSettings();

  function applySettings() {
    const root = document.documentElement;

    root.style.setProperty("--spark-text-scale", settings.textSize);
    root.setAttribute("data-spark-font", settings.font);
  }

  function saveSettings() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {
      console.warn("SparkMoto: Unable to save settings", error);
    }
  }

  function updateControls() {
    const textSize = document.getElementById("spark-text-size");
    const font = document.getElementById("spark-font");

    if (textSize) textSize.value = settings.textSize;
    if (font) font.value = settings.font;
  }

  function initializeControls() {
    const textSize = document.getElementById("spark-text-size");
    const font = document.getElementById("spark-font");
    const resetAll = document.getElementById("spark-reset-all");

    if (textSize) {
      textSize.addEventListener("change", function () {
        settings.textSize = this.value;
        applySettings();
        saveSettings();
      });
    }

    if (font) {
      font.addEventListener("change", function () {
        settings.font = this.value;
        applySettings();
        saveSettings();
      });
    }

    if (resetAll) {
      resetAll.addEventListener("click", function () {
        settings = { ...defaults };
        applySettings();
        saveSettings();
        updateControls();
      });
    }

    updateControls();
  }

  applySettings();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeControls);
  } else {
    initializeControls();
  }
})();